import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { InfoIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface MarketSizeInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  tooltip: string;
}

export const MarketSizeInput = ({
  label,
  value,
  onChange,
  tooltip,
}: MarketSizeInputProps) => {
  return (
    <Card className="p-4">
      <div className="flex items-center gap-2 mb-2">
        <Label htmlFor={label}>{label}</Label>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <InfoIcon className="h-4 w-4 text-gray-400" />
            </TooltipTrigger>
            <TooltipContent>
              <p className="max-w-xs">{tooltip}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <Input
        id={label}
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="text-lg"
        placeholder="Enter amount..."
      />
    </Card>
  );
};